import { RelatedServicesStyle } from '../../styles/components/country';

export interface IRelatedService {
  title: string;
  description?: string;
  link: string;
}

export interface IRelatedServices {
  title: string;
  services: IRelatedService[];
}

const RelatedServices = (props: IRelatedServices) => {
  return (
    <div className={RelatedServicesStyle['related-services']}>
      <h2 className="is-text-align-center">{props.title}</h2>
      <div className={RelatedServicesStyle['related-services-list']}>
        {props.services.map((service, index) => (
          <div
            key={index}
            className={RelatedServicesStyle['related-services-list-item']}>
            <h3>
              <a key={index} href={service.link}>
                {service.title}
              </a>
            </h3>
            {service.description && <p>{service.description}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedServices;
